<script lang="ts">
	// Genuine shadcn-svelte Checkbox (bits-ui), RESTYLED to price-check tokens.
	// Check/Minus icons use lucide-core via our Icon wrapper (not @lucide/svelte).
	// NO arbitrary `[..]` values.
	import { Checkbox as CheckboxPrimitive } from "bits-ui";
	import { cn, type WithoutChildrenOrChild } from "../../../utils.js";
	import { Check, Minus } from "lucide";
	import Icon from "../../../icon.svelte";

	let {
		ref = $bindable(null),
		checked = $bindable(false),
		indeterminate = $bindable(false),
		class: className,
		...restProps
	}: WithoutChildrenOrChild<CheckboxPrimitive.RootProps> = $props();
</script>

<CheckboxPrimitive.Root
	bind:ref
	data-slot="checkbox"
	class={cn(
		"peer relative flex size-4 shrink-0 items-center justify-center rounded-xs border border-border bg-surface outline-none transition-colors data-checked:border-brand data-checked:bg-brand data-checked:text-on-brand focus-visible:border-brand focus-visible:ring-2 focus-visible:ring-brand disabled:cursor-not-allowed disabled:opacity-55",
		className
	)}
	bind:checked
	bind:indeterminate
	{...restProps}
>
	{#snippet children({ checked, indeterminate })}
		<div
			data-slot="checkbox-indicator"
			class="grid place-content-center text-current transition-none"
		>
			{#if checked}
				<Icon icon={Check} size={14} />
			{:else if indeterminate}
				<Icon icon={Minus} size={14} />
			{/if}
		</div>
	{/snippet}
</CheckboxPrimitive.Root>
